'use client';

import { useEffect, useMemo } from 'react';
import { resolveBool, resolveLiteralBoolean, resolvePath } from '@macaron-a2ui/core/v0_8';
import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronBooleanAllOf({ config, ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  const outputPath = resolvePath(config.output);
  const initialOutput = resolveLiteralBoolean(config.output);
  const updateData = ctx.updateData;
  const inputs = useMemo(
    () => (Array.isArray(config.inputs) ? config.inputs : []).filter((input): input is RecordAny => Boolean(input && typeof input === 'object' && (typeof input.path !== 'string' || input.path !== outputPath))),
    [config.inputs, outputPath],
  );
  const nextValue = useMemo(() => inputs.length > 0 && inputs.every((input) => resolveBool(input, ctx.data)), [ctx.data, inputs]);

  useEffect(() => {
    if (!outputPath || initialOutput === undefined) return;
    updateData?.(outputPath, initialOutput);
  }, [initialOutput, outputPath, updateData]);
  useEffect(() => {
    if (!outputPath) return;
    updateData?.(outputPath, nextValue);
  }, [nextValue, outputPath, updateData]);

  return null;
}
